module.exports = __webpack_public_path__ + "static/3-1fda86d74ce1c7492e3e2fa4db7276c9.jpg";